import { RedoRoundedIcon, UndoRoundedIcon } from "@l2r-front/l2r-icons"

export const STATUS_DONE = 100
export const STATUS_TODO = 50
export const STATUS_RECOMMENDED = 25
export const STATUSES = [STATUS_RECOMMENDED, STATUS_TODO, STATUS_DONE]
export const STATUS_ORDER = {
    [STATUS_TODO]: 2,
    [STATUS_RECOMMENDED]: 1,
    [STATUS_DONE]: 0,
}

export const statusesSettings = {
    [STATUS_TODO]: {
        label: "forms.techniquesFiltersForm.inputs.statuses.todo",
        statusLabel: "components.techniqueCardItem.status.todo",
        order: 3,
        allowedStatusTransitions: {
            iso: (roadwork) => [
                ...(roadwork.year === new Date().getFullYear()
                    ? [{ status: STATUS_DONE, icon: <RedoRoundedIcon /> }]
                    : []),
                { status: STATUS_RECOMMENDED, icon: <UndoRoundedIcon color="action/disabled" /> },
            ],
            notIso: (roadwork) => roadwork.year === new Date().getFullYear() ? [{ status: STATUS_DONE, icon: <RedoRoundedIcon /> }] : [],
        },
    },
    [STATUS_DONE]: {
        label: "forms.techniquesFiltersForm.inputs.statuses.done",
        statusLabel: "components.techniqueCardItem.status.done",
        order: 1,
        allowedStatusTransitions: {
            iso: () => [
                { status: STATUS_TODO, icon: <UndoRoundedIcon color="action/disabled" /> },
                { status: STATUS_RECOMMENDED, icon: <UndoRoundedIcon color="action/disabled" /> },
            ],
            notIso: () => [{ status: STATUS_TODO, icon: <UndoRoundedIcon color="action/disabled" /> }],
        },
    },
    [STATUS_RECOMMENDED]: {
        label: "forms.techniquesFiltersForm.inputs.statuses.recommended",
        statusLabel: "components.techniqueCardItem.status.recommended",
        order: 2,
        allowedStatusTransitions: {
            iso: (roadwork) => [
                ...(roadwork.year === new Date().getFullYear()
                    ? [{ status: STATUS_DONE, icon: <RedoRoundedIcon /> }]
                    : []),
                { status: STATUS_TODO, icon: <RedoRoundedIcon /> },
            ],
            notIso: (roadwork) => [
                ...(roadwork.year === new Date().getFullYear()
                    ? [{ status: STATUS_DONE, icon: <RedoRoundedIcon /> }]
                    : []),
                { status: STATUS_TODO, icon: <RedoRoundedIcon /> },
            ],
        },
    },
}